"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var player_icon_1 = require("player-icon");
exports.Icon = player_icon_1.default;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Icon"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-common-controls/controls/Icon/index.js
// module id = 957
// module chunks = 0